<template>
  <kst-modal-search
    :module="Model.Module"
    :moduleType="Model.ModuleType.SearchList"
    :searchData="searchData"
    :title="Info.Dialog.SearchListPrice.Title"
    :width="1000"
    @init="handleModal_init"
    @load="handleModal_load"
    @reset="handleModal_reset"
    @submit="handleModal_submit"
  >
    <template #search="{ handleInput }">
      <Search
        :searchData="searchData"
        @input="handleInput"
      />
    </template>

    <template #search-result="{ data, userData }">
      <List
        :dataList="data.InvoiceList"
        :userData="userData"
        :sellPrice="sellPrice"
      />
    </template>
  </kst-modal-search>
</template>

<script>
import AppCatalog from "../../../services/App/AppCatalog.js";
import AppModule from "../../../services/App/AppModule.js";
import SnackbarMixin from "../../../mixins/SnackbarMixin.js";
import Info from "../InvInfo.js";
import Model from "../InvModel.js";

import List from "./InvScLPrice_List.vue";
import Search from "./InvScLPrice_Search.vue";

export default {
  mixins: [SnackbarMixin],
  components: {
    List,
    Search
  },
  data: () => ({
    Info: Info,
    Model: Model,
    searchData: {
      Search: "",
      DispatchID: null,
      ClientID: null,
      Client: "",
      Date: null
    },
    sellPrice: 0,
    packagingList: [],
    getListService: null,
    // func
    hideFunc: null,
    showFunc: null
  }),
  methods: {
    /*** public method ***/

    show(dispatchId, clientId, clientName, sellPrice, packagingList,
      getListService
    ) {
      this.searchData.DispatchID = dispatchId;
      this.searchData.ClientID = clientId;
      this.searchData.Client = clientName;
      this.sellPrice = sellPrice;
      this.packagingList = packagingList;

      this.getListService = getListService;
      this.showFunc();
    },

    /*** by modal ***/

    handleModal_init(show, hide) {
      this.showFunc = show;
      this.hideFunc = hide;
      this.resetData();

      this.$emit(this.$kst.Enum.Event.Init, this.show);
    },

    handleModal_load(loadList) {
      const options = this.getListOptions();
      const config = this.getListService(options);
      loadList(config);
    },

    handleModal_reset(loadList) {
      this.resetData();
      this.handleModal_load(loadList);
    },

    handleModal_submit(selected) {
      let isFound = false;
      for (const packaging of this.packagingList) {
        if (packaging.Name === selected.PackagingName) {
          isFound = true;
          break;
        }
      }

      if (!isFound) {
        this.notifyFormError(false, AppModule.ItemPackaging.FullName + " " +
          selected.PackagingName + " " + AppCatalog.Message.NotAvailable
        );
        return;
      }

      this.$emit(this.$kst.Enum.Event.Submit, selected);
      this.hideFunc();
    },

    /*** custom ***/

    getListOptions() {
      const clientId = this.$kst.Out.getInteger(this.searchData.ClientID);
      const clientName = clientId === null
        ? this.$kst.Out.getString(this.searchData.Client) : null;

      return {
        item: this.$kst.Out.getInteger(this.searchData.DispatchID),
        client: clientId,
        clientname: clientName,
        startdate: this.$kst.Out.getDateString(this.searchData.Date[0]),
        enddate: this.$kst.Out.getDateString(this.searchData.Date[1]),
        search: this.$kst.Out.getString(this.searchData.Search),
        field: Model.Search.ListFields
      };
    },

    resetData() {
      // searchData
      this.searchData.Search = "";
      this.searchData.Date = this.$kst.In.getThreeMonthDay();
    }
  }
}
</script>